


















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Vnodes from '@/components/helpers/vnode-helper';
import ThreePanelConditionCategoryItemAction from './three-panel-condition-category-item-action.vue';
import ThreePanelConditionCategoryItemActionSubItem from './three-panel-condition-category-item-action-sub-item.vue';

// <vnodes :vnodes="parent.genAction(item, parent.hasItem(item))"/>

@Component({
  components: {
    Vnodes,
    ThreePanelConditionCategoryItemAction,
    ThreePanelConditionCategoryItemActionSubItem
  }
})
export default class ThreePanelConditionCategoryItem extends Vue {
  @Prop()
  selectedBrands: any[];

  @Prop()
  brandSelectAllIndex: any[];

  @Prop()
  selectedKeysIndex: any[];

  @Prop()
  item: any;

  @Prop()
  prefix: string;

  @Emit('toggle')
  onToggle(item: any) {}

  @Emit('select-all')
  onSelectAll(item: any) {}

  @Prop()
  focused: string;

  @Prop()
  firstPanel: string; 

  @Prop({default: true})
  noEvents: boolean; 

  genAction() {
    return this.firstPanel 
      ? this.genActionForFirstPanel() 
      : this.genActionForSecondPanel();
  }

  genActionForFirstPanel() {
    return this.$createElement(ThreePanelConditionCategoryItemAction, {
      attrs: {
        selectedBrands: this.selectedBrands,
        brandSelectAllIndex: this.brandSelectAllIndex,
        item: this.item,
        prefix: this.prefix,
        noEvents: this.noEvents
      },
      on: {
        toggle: (item: any) => {
          this.onToggle(item);
          this.onSelectAll(item);
        }
      }
    });
  }

  genActionForSecondPanel() {
    return this.$createElement(ThreePanelConditionCategoryItemActionSubItem, {
      attrs: {
        selectedKeysIndex: this.selectedKeysIndex,
        item: this.item,
        prefix: this.prefix,
        noEvents: this.noEvents
      },
    });
  }

  pFocused: string = '';
  // pSelectedKeys: any[] = [];
  // pSelectedBrands: any[] = [];

  data() {
    return {
      pFocused: this.focused,
      // pSelectedKeys: this.selectedKeys,
      // pSelectedBrands: this.selectedBrands
    }
  }

  mounted() {
    if(!this.noEvents) {
      this.bus.on(this.prefix + '-focused', this.onBusFocused);
    }
  }

  beforeDestroy() {
    if(!this.noEvents) {
      this.bus.off(this.prefix + '-focused', this.onBusFocused);
    }
  }

  onBusFocused(focused: string) {
    this.pFocused = focused;
  }

  // onBusSelectedKeys(selectedKeys: any[]) {
  //   this.pSelectedKeys = selectedKeys;
  // }

  // onBusSelectedBrands(selectedBrands: any[]) {
  //   this.pSelectedBrands = selectedBrands;
  // }

  get isFocused() {
    return this.pFocused === this.item.name;
  }

  // get isPickedAll() {
  //   return false;
  //   let picked = true;
  //   this.item.data.forEach((e: string) => {
  //     if (this.pSelectedKeys.indexOf(e) === -1) {
  //       picked = false;
  //       return picked;
  //     }
  //   });
  //   return picked;
  // }

  // get isBrandSelected() {
  //   return false;
  //   return this.pSelectedBrands.indexOf(this.item.name) !== -1;
  // }
}
